import React, { useState } from "react";
import "./Css/EmployeeManagement.css";

const employeeFields = [
  { name: "name", label: "Name", type: "text" },
  { name: "designation", label: "Designation", type: "text" },
  { name: "category", label: "Category", type: "text" },
  { name: "deploymentArea", label: "Deployment Area", type: "text" },
  { name: "responsibility", label: "Responsibility", type: "text" },
  { name: "reportingTo", label: "Reporting To", type: "text" },
  { name: "speakUpReporting", label: "Speak-Up Reporting", type: "text" },
  { name: "mdlzSpoc", label: "MDLZ SPOC", type: "text" },
  {
    name: "contactNo",
    label: "Contact No",
    type: "tel",
    pattern: "[0-9]{10}",
    placeholder: "10-digit number",
  },
];

const emptyEmployee = Object.fromEntries(
  employeeFields.map((f) => [f.name, ""])
);

function AddEmployee({ onBack }) {
  const [formData, setFormData] = useState(emptyEmployee);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (obj) => employeeFields.every((f) => !!obj[f.name].trim());

  const handleSubmit = async (e) => {
    e.preventDefault();

    const storedUser = window.sessionStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    console.log(user, "user");

    if (!validate(formData)) {
      alert("Please fill all fields.");
      return;
    }

    if (!user) {
      alert("User not logged in. Please log in first.");
      return;
    }

    try {
      setLoading(true);
      const payload = { ...formData, userId: user.id, userRole: "Employee" };
      const response = await fetch(
        "https://mondelezbc.vsmglobaltechnologies.com/api/user/create",
        {
          // 👈 change URL to match your backend route
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("Employee added successfully!");
        onBack(); // Go back to management page
      } else {
        alert(result.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="header-row mb-4 d-flex justify-content-between align-items-center">
        <h3>Add Employee</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          {employeeFields.map((field) => (
            <div className="col-md-6 mb-3" key={field.name}>
              <label
                className="form-label"
                style={{ textAlign: "start", display: "block" }}
              >
                {field.label} *
              </label>
              <input
                {...field}
                className="form-control"
                value={formData[field.name]}
                onChange={handleChange}
                required
                placeholder={field.placeholder || ""}
              />
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-end mt-3 gap-2">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onBack}
            disabled={loading}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Saving..." : "Add Employee"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddEmployee;
